export const RTL_LANGUAGE_CODES = [
  'ar',
  'fa',
  'he',
  'iw',
  'ps',
  'sd',
  'ug',
  'ur',
  'yi',
] as const;

export type TextDirection = 'ltr' | 'rtl';

export const INTERNAL_LOCALE_SEPARATOR = '__';

export const getPublicLocale = (language: string | undefined): string =>
  language?.split(INTERNAL_LOCALE_SEPARATOR)[1] ?? 'en';

export const getLocaleDirection = (
  locale: string | undefined | null
): TextDirection => {
  const baseLanguage = locale?.toLowerCase().split(/[-_]/)[0];

  return baseLanguage &&
    (RTL_LANGUAGE_CODES as readonly string[]).includes(baseLanguage)
    ? 'rtl'
    : 'ltr';
};
